import choiceService, { cacheName } from './choiceService';
import { addDataIntoCache, checkIfDataIsCached } from '../browser-cache.js';

// export const getConfig = async () => {
//     try {
//         const url = `/v1.0/config`;
//         const res = await choiceService.get(url); //TODO: deal with axois vs service calls in another file
//         return(res.data);
//     } catch (error) {
//         console.error(" error trying to getConfig");
//         return(undefined);
//     }    
// }


export const getMe = async () => {
    try {
        const url = `/v1.0/me`;
        const res = await choiceService.get(url);
        return(res.data);
    } catch (err) {
        console.error(" error trying to getMe");
        return(undefined);
    }    
}

export const getLookup = async (listName, bypassCache = true) => {
    try {
        const url = `/v1.0/lookup/${listName}`;
        let res = await checkIfDataIsCached(cacheName, url);
        if (res === undefined || bypassCache) {
            res = await choiceService.get(url);
            await addDataIntoCache(cacheName, url, res);
        }
        const options = res.data;
        return(options);
    } catch (error) {
        console.error(" error trying to getLookup");
        return(undefined);
    }    
}

export const signPrivacyAgreement = async (signed) => {
    try {
        const url = `/v1.0/me/agreement`;
        const res = await choiceService.put(url, {signed});
        return (res.data);
    } catch (err) {
        console.error(" error trying to getMe");
        return (undefined);
    }
}
